import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';


export interface ActionMenuItem {
  id: string;
  type: 'action' | 'group';
  label: string;
  icon?: string;
  children?: ActionMenuItem[];
  [key: string]: any;
}

/**
 * Menu-group-button - a button, with optional grouping.
 * Items can be grouped two levels for a drop-down menu with more options.
 * not a recursive component because of https://github.com/angular/components/issues/26243 (no accessibility)
 */
@Component({
    selector: 'app-menu-group-button',
    imports: [
    MatButton,
    MatIcon,
    TranslateModule,
    MatMenuItem,
    MatMenu,
    MatMenuTrigger
],
    templateUrl: './menu-group-button.component.html',
    styleUrl: './menu-group-button.component.scss'
})
export class MenuGroupButtonComponent {

  @Input() item: ActionMenuItem;
  @Input() disabled?: boolean = false;
  @Input() readonly?: boolean = false;
  @Output() itemClick = new EventEmitter<ActionMenuItem>()

}
